import { connection } from '@/lib/http/connection';

export interface YouTubeChannelData {
    title: string;
    avatar?: string;
    banner?: string;
    customUrl?: string;
    subscriberCount?: string;
}

export async function getYouTubeChannelData(
    handle?: string,
    channelId?: string
): Promise<YouTubeChannelData | null> {
    return connection<YouTubeChannelData>('/api/social/youtube', {
        query: { handle, channelId },
    }).catch(() => null);
}
